import { render, staticRenderFns } from "./AddLeaderBoardTeam.vue?vue&type=template&id=689f4eb0&scoped=true"
import script from "./AddLeaderBoardTeam.vue?vue&type=script&lang=js"
export * from "./AddLeaderBoardTeam.vue?vue&type=script&lang=js"
import style0 from "./AddLeaderBoardTeam.vue?vue&type=style&index=0&id=689f4eb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689f4eb0",
  null
  
)

export default component.exports